export default "__VITE_ASSET__Boe8g7Lu__"